import * as React from "react";
import styles from "./LoadingSpinner.module.scss"

interface LoaderProps {
    message?: string;
    fontSize?: string;
    paddingBlock?: string;
    spinnerColor?: string;
}

const Loader: React.FunctionComponent<LoaderProps> = (props) => {
    return (
        <section className={styles["loader-container"]}>
            <span className={styles.message} style={{ '--font-size': props.fontSize, '--padding-block': props.paddingBlock } as React.CSSProperties}>{props.message || "Loading. . . "}</span>
            <div className={styles.loader} style={{'--spinner-color': props.spinnerColor || "var(--hgs-blue)"} as React.CSSProperties}></div>
        </section>
    );
};

export default Loader;